import React, { useContext, useEffect, useState } from 'react';
import { DataGrid, GridColDef, GridRenderCellParams, GridSortModel } from '@mui/x-data-grid';
import endpoints from '../constants/endpoints';
import useFetch from '../hooks/useFetch';
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControlLabel, IconButton, Switch, Typography } from '@mui/material';
import { GlobalStateContext } from '../wrappers/GlobalContext';
import { toCurrency, toFormatedNumber } from '../utils/helpers';
import useApiRequest from '../services/apiRequest';
import { Close, LocalAtm } from '@mui/icons-material';
import Detail from './Detail';
import InfoIcon from '@mui/icons-material/Info';
import InfoDialog from './InfoDialog';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import BackupTableIcon from '@mui/icons-material/BackupTable';
import DownloadMenu from './DownloadMenu';
import navbar_background from '../assets/navbar_background.svg';



function ResultsTable() {
    const { queryStringConverter } = useApiRequest();

    const { userPermissions } = useContext(GlobalStateContext);
    const [pageSize, setPageSize] = useState<number>(100);
    const [currentPage, setCurrentPage] = useState<number>(0);
    const [sortField, setSortField] = useState('_score');
    const [sortOrder, setSortOrder] = useState('desc');
    const { description, filters, searchType: search_type } = useContext(GlobalStateContext);
    const { overpriceChartFilter, setOverpriceChartFilter } = useContext(GlobalStateContext);
    const { overpriceChartFilterAux, setOverpriceChartFilterAux } = useContext(GlobalStateContext);
    const { currentUser, setCurrentUser } = React.useContext(GlobalStateContext);
    const { data, error, loading } = useFetch(`${endpoints.ITEMS + `/${currentUser?.profile.username}`}${queryStringConverter({ page: currentPage, size: pageSize, sort: sortField, order: sortOrder, search_type })}`, JSON.stringify({ description, ...filters }), "POST")
    const [showModalDetail, setShowModalDetail] = useState<any>(null)
    const [showExportModal, setShowExportModal] = useState<boolean>(false)
    const [openInfo, setOpenInfo] = useState(false);
    const [info, setInfo] = useState({});
    const [openMore, setOpenMore] = useState(false);



    const [hideDescricao, setHideDescricao] = useState(false);
    const [hideUndMedida, setHideUndMedida] = useState(false);
    const [hideSrvPrd, setHideSrvPrd] = useState(false);
    const [hidePrecoUni, setHidePrecoUni] = useState(false);
    const [hideQuantidade, setHideQuantidade] = useState(false);
    const [hideData, setHideData] = useState(false);

    const [hidePrimeiroTermo, setHidePrimeiroTermo] = useState(true);
    const [hideLicitacao, setHideLicitacao] = useState(true);
    const [hideMunicipio, setHideMunicipio] = useState(true);
    const [hideOrgao, setHideOrgao] = useState(true);
    const [hideModalidade, setHideModalidade] = useState(true);
    const [hideTipoLicitacao, setHideTipoLicitacao] = useState(true);
    const [hideNumProcesso, setHideNumProcesso] = useState(true);
    const [hideNumModalidade, setHideNumModalidade] = useState(true);
    const [hideDscDocument, setHideDscDocument] = useState(true)
    const [hideNomeVencedor, setHideNomeVencedor] = useState(true);
    const [hidePalavras, setHidePalavras] = useState(true);
    const [hideDscCanonical, setHideDscCanonical] = useState(true);

    const renderCellInfo = (params: GridRenderCellParams) => {
        return (
            <IconButton color="primary" aria-label="add to shopping cart" onClick={() => {
                setOpenInfo(true)
                setInfo(params.row)
            }}>
                <InfoIcon />
            </IconButton>
        )
    }

    const renderCellMore = (params: GridRenderCellParams) => {
        return (
            <IconButton color='warning' aria-label="add to shopping cart" onClick={() => { setOpenMore(true) }}>
                <AddCircleIcon />
            </IconButton>
        )
    }

    const columns: GridColDef[] = [

        { field: 'original_dsc', headerName: 'Descrição Item', flex: 1, minWidth: 250, hide: hideDescricao },
        { field: 'fonte', headerName: 'Fonte', flex: 1, minWidth: 150, hide: hideDescricao },
        { field: 'dsc_unidade_medida', headerName: 'Unid. Medida', flex: 1, minWidth: 130, hide: hideUndMedida },
        { field: 'flag_produto_servico', headerName: 'Srv / Prd', hide: hideSrvPrd },
        { field: 'preco', headerName: 'Preço unitário (R$)', flex: 1, minWidth: 150, align: 'left', headerAlign: 'left', hide: hidePrecoUni },
        { field: 'qtde_item', headerName: 'Quantidade', align: 'left', headerAlign: 'left', hide: hideQuantidade },
        { field: 'periodo', headerName: 'Período', minWidth: 110, align: 'left', headerAlign: 'left', hide: hideData },
        //escondidas

        { field: 'id_licitacao', headerName: 'Documento', flex: 1, minWidth: 120, hide: hideLicitacao },
        { field: 'municipio', headerName: 'Municipio', minWidth: 250, align: 'left', headerAlign: 'left', hide: hideMunicipio },
        { field: 'orgao', headerName: 'Orgão', minWidth: 250, align: 'left', headerAlign: 'left', hide: hideOrgao },
        { field: 'modalidade', headerName: 'Modalidade', minWidth: 250, align: 'left', headerAlign: 'left', hide: hideModalidade },
        { field: 'tipo_licitacao', headerName: 'Tipo de Licitação', minWidth: 250, align: 'left', headerAlign: 'left', hide: hideTipoLicitacao },
        { field: 'num_processo', headerName: 'Número do Processo', minWidth: 200, align: 'left', headerAlign: 'left', hide: hideNumProcesso },
        { field: 'num_modalidade', headerName: 'Número da Modalidade', minWidth: 200, align: 'left', headerAlign: 'left', hide: hideNumModalidade },
        { field: 'dsc_document', headerName: 'Descrição do Documento', minWidth: 200, align: 'left', headerAlign: 'left', hide: hideDscDocument },
        { field: 'nome_vencedor', headerName: 'Fornecedor', minWidth: 250, align: 'left', headerAlign: 'left', hide: hideNomeVencedor },
        { field: 'palavras', headerName: 'Descrição processada', minWidth: 250, align: 'left', headerAlign: 'left', hide: hidePalavras },
        { field: 'primeiro_termo', headerName: 'Primeiro termo', flex: 1, minWidth: 120, hide: hidePrimeiroTermo },
        { field: 'dsc_canonical', headerName: 'Descrição automática', minWidth: 250, align: 'left', headerAlign: 'left', hide: hideDscCanonical },

        { field: 'info', headerName: 'Info', width: 20, align: 'left', headerAlign: 'left', renderCell: renderCellInfo, sortable: false },

    ];

    const formatedData = () => data.data.map((d: any) => ({
        ...d,
        preco: toCurrency(d.preco),
        qtde_item: toFormatedNumber(d.qtde_item),
        periodo: d.periodo ? d.periodo.slice(4, 6) + "/" + d.periodo.slice(0, 4) : " "
    }))


    const printClick = async () => {
        setShowExportModal(true);
    };


    const onCloseDetail = () => {
        setShowModalDetail(false);
        setOverpriceChartFilter(overpriceChartFilterAux);
    }

    const handleCloseMore = () => {
        setOpenMore(false);
    }

    const showAllColumns = () => {
        setHideMunicipio(false);
        setHideOrgao(false);
        setHideModalidade(false);
        setHideTipoLicitacao(false);
        setHideNumProcesso(false);
        setHideNumModalidade(false);
        setHideNomeVencedor(false);
        setHidePalavras(false);
        setHideDscCanonical(false);
        setHideLicitacao(false);
        setHideDescricao(false);
        setHideUndMedida(false);
        setHideSrvPrd(false);
        setHidePrecoUni(false);
        setHideQuantidade(false);
        setHideData(false);
    };

    const hideAllColumns = () => {
        setHideMunicipio(true);
        setHideOrgao(true);
        setHideModalidade(true);
        setHideTipoLicitacao(true);
        setHideNumProcesso(true);
        setHideNumModalidade(true);
        setHideNomeVencedor(true);
        setHidePalavras(true);
        setHideDscCanonical(true);
        setHideLicitacao(true);
        setHideDescricao(true);
        setHideUndMedida(true);
        setHideSrvPrd(true);
        setHidePrecoUni(true);
        setHideQuantidade(true);
        setHideData(true);
    };

    const handleSortModelChange = React.useCallback((sortModel: GridSortModel) => {
        setSortField(sortModel[0].field);
        setSortOrder(sortModel[0].sort || '');
    }, []);

    return (
        <>
            <Dialog open={openMore} onClose={handleCloseMore}>
                <DialogTitle color='white' sx={{ bgcolor: '#00617b', backgroundImage: `url(${navbar_background})`, backgroundSize: "cover" }}>
                    <Typography variant='h4'>Gerenciar colunas da tabela</Typography>
                    <IconButton
                        aria-label="close"
                        onClick={() => { handleCloseMore() }}
                        sx={{
                            position: 'absolute',
                            right: 15,
                            top: 15,
                        }}
                    >
                        <Close sx={{ color: "white" }} />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'row', mt: 1 }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="h5" color="initial" textAlign={'center'} sx={{ mb: 1 }}>Documento</Typography>
                            <FormControlLabel
                                control={
                                    <Switch checked={!hideData} onChange={() => setHideData(!hideData)} name="gilad" />
                                }
                                label="Período"
                            />
                            <FormControlLabel
                                control={
                                    <Switch checked={!hideLicitacao} onChange={() => setHideLicitacao(!hideLicitacao)} name="gilad" />
                                }
                                label="Documento"
                            />
                            <FormControlLabel
                                control={
                                    <Switch checked={!hideMunicipio} onChange={() => setHideMunicipio(!hideMunicipio)} name="gilad" />
                                }
                                label="Município"
                            />

                            <FormControlLabel
                                control={
                                    <Switch checked={!hideOrgao} onChange={() => setHideOrgao(!hideOrgao)} name="gilad" />
                                }
                                label="Orgão"
                            />

                            <FormControlLabel
                                control={
                                    <Switch checked={!hideModalidade} onChange={() => setHideModalidade(!hideModalidade)} name="gilad" />
                                }
                                label="Modalidade"
                            />

                            <FormControlLabel
                                control={
                                    <Switch checked={!hideTipoLicitacao} onChange={() => setHideTipoLicitacao(!hideTipoLicitacao)} name="gilad" />
                                }
                                label="Tipo de Licitação"
                            />

                            <FormControlLabel
                                control={
                                    <Switch checked={!hideNumProcesso} onChange={() => setHideNumProcesso(!hideNumProcesso)} name="gilad" />
                                }
                                label="Número do Processo"
                            />

                            <FormControlLabel
                                control={
                                    <Switch checked={!hideNumModalidade} onChange={() => setHideNumModalidade(!hideNumModalidade)} name="gilad" />
                                }
                                label="Número da Modalidade"
                            />
                            <FormControlLabel
                                control={
                                    <Switch checked={!hideDscDocument} onChange={() => setHideDscDocument(!hideDscDocument)} name="gilad" />
                                }
                                label="Descrição do Documento"
                            />

                            <FormControlLabel
                                control={
                                    <Switch checked={!hideNomeVencedor} onChange={() => setHideNomeVencedor(!hideNomeVencedor)} name="gilad" />
                                }
                                label="Fornecedor"
                            />

                        </Box>

                        <Divider orientation="vertical" flexItem />

                        <Box sx={{ display: 'flex', flexDirection: 'column', ml: 1 }}>
                            <Typography variant="h5" color="initial" textAlign={'center'} sx={{ mb: 1 }}>Item</Typography>
                            <FormControlLabel
                                control={
                                    <Switch checked={!hideDescricao} onChange={() => setHideDescricao(!hideDescricao)} name="gilad" />
                                }
                                label="Descrição Item"
                            />

                            <FormControlLabel
                                control={
                                    <Switch checked={!hideUndMedida} onChange={() => setHideUndMedida(!hideUndMedida)} name="gilad" />
                                }
                                label="Unid. Medida"
                            />
                            <FormControlLabel
                                control={
                                    <Switch checked={!hideSrvPrd} onChange={() => setHideSrvPrd(!hideSrvPrd)} name="gilad" />
                                }
                                label="Srv / Prd"
                            />
                            <FormControlLabel
                                control={
                                    <Switch checked={!hidePrecoUni} onChange={() => setHidePrecoUni(!hidePrecoUni)} name="gilad" />
                                }
                                label="Preço unitário (R$)"
                            />
                            <FormControlLabel
                                control={
                                    <Switch checked={!hideQuantidade} onChange={() => setHideQuantidade(!hideQuantidade)} name="gilad" />
                                }
                                label="Quantidade"
                            />
                            <FormControlLabel
                                control={
                                    <Switch checked={!hidePalavras} onChange={() => setHidePalavras(!hidePalavras)} name="gilad" />
                                }
                                label="Descrição processada"
                            />
                            <FormControlLabel
                                control={
                                    <Switch checked={!hidePrimeiroTermo} onChange={() => setHidePrimeiroTermo(!hidePrimeiroTermo)} name="gilad" />
                                }
                                label="Primeiro Termo"
                            />




                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 2 }}>
                        <Button variant="text" color="primary" onClick={hideAllColumns}>
                            Ocultar Todas
                        </Button>
                        <Button variant="text" color="primary" onClick={showAllColumns}>
                            Mostrar Todas
                        </Button>
                    </Box>

                </DialogContent>
            </Dialog>
            <div className=''>
                <InfoDialog open={openInfo} onClose={() => { setOpenInfo(false) }} info={info} />
                {showModalDetail ? <Detail open onClose={onCloseDetail} /> : null}
                <div className='bg-white'>

                    {loading || !data
                        ? <div className='h-result flex flex-col justify-center items-center'><CircularProgress /></div>
                        :
                        [
                            <div className='h-result px-2'>

                                <DataGrid
                                    hideFooterSelectedRowCount
                                    paginationMode='server'
                                    pageSize={pageSize}
                                    rows={formatedData()}
                                    rowCount={data.total}
                                    page={currentPage}
                                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                                    onPageChange={(newPage) => setCurrentPage(newPage)}
                                    columns={columns}
                                    getRowId={(e: any) => e.id_item}
                                    sx={{ fontSize: 13 }}
                                    onSortModelChange={handleSortModelChange}
                                />

                                <Box sx={{ display: 'flex', mt: '-3.5%', ml: 1 }}>
                                    <Button sx={{ mr: 1 }} disabled={!userPermissions.get_aggregate} variant="contained" onClick={() => setShowModalDetail(true)} startIcon={<LocalAtm />} >Análise de preço</Button>
                                    <DownloadMenu />
                                    <Button sx={{ ml: 1 }} variant="contained" onClick={() => setOpenMore(true)} startIcon={<BackupTableIcon />}>Gerenciar Tabela</Button>

                                </Box>
                            </div>

                        ]
                    }
                </div>
            </div>
        </>

    );
}

export default ResultsTable;
